import routerOptions0 from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}